"use client";

import React, { useState } from "react";
import toast from "react-hot-toast";
import obituaryService from "@/services/obituary-service";

export default function PrivateMemoryGate({ obituary, onUnlocked }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e?.preventDefault();
    if (!password.trim()) {
      toast.error("Vnesite geslo");
      return;
    }

    try {
      setLoading(true);
      const res = await obituaryService.verifyObituaryPassword(obituary.id, password);
      if (res?.success && res?.accessToken) {
        // The code is asked again on every visit: the access lives only in the open page, never in the browser's storage.
        toast.success("Geslo je pravilno");
        if (onUnlocked) onUnlocked(res.accessToken);
      } else {
        toast.error(res?.error || "Napačno geslo");
      }
    } catch (err) {
      console.error("Password verification error:", err);
      const msg = err?.response?.data?.error || "Napačno geslo";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 py-12">
      <div className="w-full max-w-[480px] bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.08)] p-6 tablet:p-8 flex flex-col items-center text-center">
        <div className="w-20 h-20 rounded-full bg-[#FEF3C7] text-[#D97706] flex items-center justify-center mb-4 text-3xl">
          🔒
        </div>

        <h1 className="text-2xl tablet:text-3xl font-medium text-[#1E2125]">Zasebna spominska stran</h1>

        <div className="mt-4 px-3 py-1.5 rounded-full bg-[#FEF3C7] text-[#92400E] text-xs font-semibold flex items-center gap-1.5">
          <span>🔒</span>
          <span>Zasebna spominska stran</span>
        </div>

        <p className="text-sm text-[#4B5563] mt-4 leading-relaxed">
          Dostop do te spominske strani je zaščiten z geslom. Za ogled vnesite geslo, ki vam ga je posredoval Skrbnik.
        </p>

        <form onSubmit={handleVerify} className="w-full mt-6 flex flex-col gap-3">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Vnesite geslo"
            className="w-full h-12 px-4 rounded-lg border border-[#D1D5DB] focus:border-[#0E9CE5] focus:outline-none text-base text-[#1E2125] placeholder-[#9CA3AF] text-center"
            autoFocus
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-lg bg-gradient-to-b from-[#0E9CE5] to-[#057DC3] hover:from-[#0d8fd1] hover:to-[#046fb0] text-white font-semibold text-base shadow-md transition-all disabled:opacity-50"
          >
            {loading ? "Preverjanje..." : "Odpri spominsko stran"}
          </button>
        </form>

        <p className="text-xs text-[#9CA3AF] mt-6">
          Če nimate gesla, se obrnite na Skrbnika te spominske strani ali svojce.
        </p>
      </div>
    </div>
  );
}
